module.exports = __webpack_public_path__ + "media/application/images/newsletter-flower-31227add7c170034303696f4c47711db.png";